<div class="m-5 flex items-start justify-around gap-1">
  @if (shouldShowTimesheetSelect) {
    <button class="mt-3 w-20" mat-raised-button (click)="searchContracts()">
      <mat-icon class="!m-0 rotate-180 !text-4xl/none !leading-none" [inline]="true">exit_to_app</mat-icon>
    </button>
  } @else {
    <div class="w-20">&nbsp;</div>
  }
  <mat-form-field appearance="outline" class="w-[250px] cursor-pointer select-none" (click)="picker.open()">
    <input
      class="cursor-pointer"
      matInput
      readonly
      tabindex="-1"
      [matDatepickerFilter]="thisWeek"
      [matDatepicker]="picker"
      [formControl]="datahub.date.selectedDate"
      (blur)="searchContracts()"
    />
    <mat-label>Work Date</mat-label>
    <mat-datepicker-toggle matSuffix [for]="picker" />
    <mat-datepicker #picker touchUi disabled="false" />
  </mat-form-field>
  <cost-center-form-field />
  <div class="w-20"><!--spacer--></div>
</div>
@if (!shouldShowTimesheetSelect) {
  <div>
    <h1 class="my-5 text-center text-2xl/5">Select Your General Foreman</h1>
    <hr class="mb-4 border-[lightgray]" />
    @if (isSearching) {
      <div class="flex justify-center">
        <mat-spinner />
      </div>
    } @else {
      <div class="m-5 flex flex-row" [ngClass]="{ 'justify-center': timesheetOwners.length === 0 }">
        @if (timesheetOwners.length > 0) {
          <div class="name-block flex flex-col gap-10">
            @for (owner of timesheetOwners; track owner) {
              <div class="flex h-[125px]">
                <button
                  type="button"
                  class="flex items-stretch"
                  [class.selected]="owner.isSelected"
                  (click)="showCustGroups(owner)"
                >
                  <div class="res-circle" notranslate [ngClass]="'color' + ($index % 6)">
                    <div class="circle-txt">{{ owner.initials }}</div>
                  </div>
                  <div
                    class="box-point name-banner flex flex-col justify-center bg-white"
                    [ngClass]="{
                      'bg-[#e6e6e6]': isOwnerSelected && !owner.isSelected,
                      'bg-white': owner.isSelected || !isOwnerSelected,
                    }"
                  >
                    <span class="!mb-0 self-center text-xl/none" notranslate>{{ owner.name }}</span>
                  </div>
                </button>
                @if (owner.isSelected) {
                  <div class="z-10 flex w-[250px] select-none flex-wrap items-center justify-start gap-5">
                    @for (contract of uniqueContracts; track contract) {
                      @if (contract.isSelected) {
                        <div>
                          <div class="bg-[gray] py-1 text-center text-xl/none font-semibold uppercase text-white">
                            {{ contract.displayName }}
                          </div>
                          @for (customer of customers; track customer) {
                            <button
                              type="button"
                              class="flex h-[65px] w-[250px] cursor-pointer items-center justify-center rounded-[3px] border-[1px] border-solid bg-white p-[10px] text-center text-xl/none text-black drop-shadow-md"
                              notranslate
                              (click)="selectCustomer(customer)"
                            >
                              <span>{{ customer.ItemText }}</span>
                            </button>
                          }
                        </div>
                      } @else {
                        <button
                          class="flex flex-wrap items-center justify-center rounded-[3px] border-[1px] border-solid text-center"
                          notranslate
                          [ngClass]="{
                            'cursor-default border-none': contract.isSelected,
                            'bg-[#adadad]': !contract.isSelected && isOwnerSelected,
                            'mt-4': $first && !contract.isSelected,
                            'h-[92px] w-[250px] bg-white p-[10px]': !contract.isSelected,
                            'bg-[#e6e6e6]': !contract.isSelected && isCustGroupSelected,
                          }"
                          (click)="showCustomers(contract)"
                        >
                          <div class="self-center py-1 text-xl/none uppercase">{{ contract.displayName }}</div>
                        </button>
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          <p class="text-center text-2xl/none">
            There are no Timesheets for this cost center and date.<br />Please contact your Supervisor.
          </p>
        }
      </div>
    }
  </div>
} @else {
  <h1 class="my-5 text-center text-2xl/5">Select Timesheet</h1>
  <hr class="mb-4 border-[lightgray]" />
  @if (isSearching) {
    <div class="flex justify-center">
      <mat-spinner />
    </div>
  } @else {
    <div class="flex w-full justify-center">
      <div class="crew-box flex h-full w-4/5 justify-center">
        @if (timesheets.length > 0) {
          <div class="flex w-4/5 flex-col gap-2 px-10 py-5">
            @for (timesheet of timesheets; track timesheet) {
              <button
                class="!h-14 flex-wrap !justify-start text-left leading-snug"
                mat-raised-button
                notranslate
                (click)="selectTimesheet(timesheet)"
              >
                <div class="line-clamp-1 w-full text-wrap break-words">
                  {{ timesheet.Description }}
                </div>
                <div class="line-clamp-2 w-full text-wrap break-words text-sm text-gray-500">
                  {{ timesheet.timesheetHeaderDisplayText }}
                </div>
              </button>
            }
          </div>
        } @else {
          <p class="text-center text-2xl/none">
            There are no Timesheets for this cost center and date.<br />Please contact your Supervisor.
          </p>
        }
      </div>
    </div>
  }
}
